// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import style from './LastDeliveriesWrap.scss';
import one from '../../../../assets/img/flight/landing/orders/1.jpg';
import two from '../../../../assets/img/flight/landing/orders/2.jpg';
import three from '../../../../assets/img/flight/landing/orders/3.jpg';
import four from '../../../../assets/img/flight/landing/orders/4.jpg';
import five from '../../../../assets/img/flight/landing/orders/5.jpg';
import six from '../../../../assets/img/flight/landing/orders/6.jpg';
import seven from '../../../../assets/img/flight/landing/orders/7.jpg';
import eight from '../../../../assets/img/flight/landing/orders/8.jpg';
import nine from '../../../../assets/img/flight/landing/orders/9.jpg';
import ten from '../../../../assets/img/flight/landing/orders/10.jpg';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  index: number;
  traveler: string;
};

type LastDelivery = {
  image: string;
  product: string;
  customer: string;
};

const lastDeliveries: LastDelivery[] = [
  {
    image: one, 
    product: 'Apple iPhone 12 Red 128gb', 
    customer: 'Julia',
	}, 
  {
    image: two, 
    product: 'Apple iPhone 12 Pro Pacific Blue 128gb', 
    customer: 'Patricio',
	}, 
  {
    image: three, 
    product: 'Bose Noise Cancelling Headphones 700', 
    customer: 'Enrique',
	}, 
  {
    image: four, 
    product: 'Persol Sunglasses PO3214S', 
    customer: 'Lorena',
	}, 
  {
    image: five, 
    product: 'Alienware M15 Gaming Laptop', 
    customer: 'Jonathan',
	}, 
  {
    image: six, 
    product: 'Apple Macbook Pro 16"', 
    customer: 'Gonzalo',
	}, 
  {
    image: seven, 
    product: 'Apple iPad Pro 11 Wi-Fi 128gb', 
    customer: 'Rosa',
	}, 
  {
    image: eight, 
    product: 'Casio PRIZM FX-CG50 Color Graphing Calculator', 
    customer: 'Nicole',
	}, 
  {
    image: nine, 
    product: 'Sascha Fitness FIT9', 
    customer: 'Karina',
	}, 
  {
    image: ten, 
    product: 'Salvatore Ferragamo Men\'s Parigi Bit Driver Shoes',
    customer: 'Pablo',
	},
];

const restrictIndex = (index: number) => index % lastDeliveries.length;

export function LastDeliveries(props: Props) {
  const { index, traveler } = props;
  
  const buildLastDelivery = (lastDelivery: LastDelivery, index: number) => {
    return (
      <div key={`last-delivery-${index}`} className={style.lastDeliveryWrap}>
        <img src={lastDelivery.image} alt="product"/>
        <hr/>
        <p>{lastDelivery.product}</p>
        <div className={style.namesWrap}>
          <div className={classNames(style.pill, style.traveler)}>
            <span>{traveler}</span>
          </div>
          <i className={icons.iconDeliverBoxMedium} />
          <div className={classNames(style.pill, style.buyer)}>
            <span>{lastDelivery.customer}</span>
          </div>
        </div>
      </div>
    );
  };

  const chosenDeliveries = [
    lastDeliveries[restrictIndex(index)],
    lastDeliveries[restrictIndex(index + 1)],
    lastDeliveries[restrictIndex(index + 2)]
  ];
  
  const dls = chosenDeliveries.map((d, i) => buildLastDelivery(d, i));
  
  return (
    <div className={style.lastDeliveriesWrap}>
      <h3>Últimas entregas</h3>
      <div className={style.lastDeliveriesContent}>
        {dls}
      </div>
    </div>
  );
}

LastDeliveries.propTypes = {
  index: PropTypes.number.isRequired,
  traveler: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/flight-landing/components/LastDeliveries/LastDeliveries.jsx